import {Component, OnInit} from '@angular/core';
import { CONSTANTES } from '../../../../shared/constanst/url-scrolls-header';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html'
})
export class MainPageComponent implements OnInit {

  pageData;

  constructor() {
    this.pageData = {
      bloqueDeBienvenida: {
        scrollId: CONSTANTES.BLOQUE_BIENVENIDA
      },
      bloqueQuienesSomos: {
        scrollId: CONSTANTES.BLOQUE_QUIENES_SOMOS
      },
      features: {
        scroll_anchor_id: "features",
        headline: "Nuestros Servicios",
        subheadline: "Ofrecemos soluciones para quienes necesitan cannabis medicinal de manera segura y regulada.",
        features: [
          {
            icon: "../../../../assets/images/icons/calidad.png",
            headline: "Cannabis de Calidad",
            description: "Proporcionamos cannabis de calidad y trazabilidad a quienes no pueden cultivar por falta de medios o tiempo."
          },
          {
            icon: "../../../../assets/images/icons/ley-del-cannabis.png",
            headline: "Experiencia REPROCANN",
            description: "Ofrecemos a los pacientes inscriptos una experiencia legal de producción medicinal con los mejores métodos."
          },
          {
            icon: "../../../../assets/images/icons/aceite-de-cbd.png",
            headline: "Usos Medicinales",
            description: "Difundimos los numerosos usos medicinales del cannabis, guiando a los pacientes hacia un consumo responsable y seguro."
          },
          {
            icon: "../../../../assets/images/icons/obediente.png",
            headline: "Asesoramiento Legal",
            description: "El club cuenta con asesoramiento legal especializado y funciona bajo un modelo de estatuto seguro para clubes de cultivo."
          }
        ]
      },
      rights_section: {
        scroll_anchor_id: "rights_section",
        headline: "Defensa y Promoción de los Derechos Cannábicos",
        subheadline: "Trabajamos para garantizar el acceso justo y regulado al cannabis medicinal, promoviendo la implementación de la ley 27.350 y la defensa de los derechos de los usuarios.",
        image: "../../../assets/images/licencia-repro.jpg",
        rights: [
          {
            headline: "Acceso Seguro al Cannabis Medicinal",
            description: "Defendemos el derecho de todos los pacientes a acceder al cannabis medicinal de manera legal y segura, garantizado por la ley 27.350."
          },
          {
            headline: "Cultivo Solidario y Derecho a Cultivar",
            description: "Apoyamos el derecho de los pacientes y cultivadores solidarios a cultivar hasta 9 plantas por usuario para uso medicinal, bajo el marco legal del REPROCANN."
          },
          {
            headline: "Concientización sobre los Derechos del Usuario",
            description: "Realizamos campañas educativas sobre los derechos de los usuarios de cannabis medicinal, asegurándonos de que conozcan el marco legal que los protege."
          },
          {
            headline: "Asesoría Legal y Acompañamiento",
            description: "Ofrecemos asesoría legal para pacientes y cultivadores interesados en el uso medicinal del cannabis, brindando acompañamiento y respaldo en el proceso legal."
          }
        ]
      }
    };
  }

  ngOnInit(): void {
  }

}
